module.exports = __webpack_public_path__ + "img/kitty-left.df6062b1.png";